import React, { useContext, useState, useEffect, useRef } from 'react'
import myContext from '../../FiltersComponent/context/context'
import { removeSpecialCharacters, highlightText, getStates, loadData } from '../../Utility/Utility.js'
import GetSearchResult from '../../Utility/GetSearchResult/GetSearchResult'
import { fetchProspectingSuggestion } from '../../Services/propertySearchService'

const GetProspectingSuggestion = () => {
    const { searchCriteria, setSearchCriteria, setSearchResult, setShowSpinner } = useContext(myContext)
    const [show, setShow] = useState(false)
    const [showSuggestionSpinner, setShowSuggestionSpinner] = useState(false)
    const [prospectingSuggestions, setProspectingSuggestions] = useState([])
    const [stateSuggestions, setStateSuggestions] = useState([])
    const [inputVal, setInputVal] = useState('')
    const listStates = getStates()
    const inputProspecting = useRef(null)

    useEffect(
        () => {
            if (inputVal.length >= 3) {
                inputChanged()
            }
            if (inputVal.length === 0) {
                inputProspecting.current.focus()
            }
        },
        [inputVal]
    )

    function inputChanged() {

        if (inputVal.length >= 3) {

            const newInputValue = removeSpecialCharacters(inputVal)

            setShow(true)

            let suggestionCriteria = {}
            let payLoad = ''

            if (newInputValue.length > 3) {
                setShowSuggestionSpinner(true)
            }

            suggestionCriteria = {
                text: newInputValue
            }

            payLoad = JSON.stringify({
                suggestion: suggestionCriteria
            })

            fetchStateSuggestion()

            fetchSuggestion(payLoad)

        }
    }

    function isShowSuggestions(onFocus) {
        let newShow = false
        if ((prospectingSuggestions.length > 0 || stateSuggestions.length > 0) && onFocus) {
            newShow = true
        }

        setShow(newShow)
    }

    function handleChange(e) {
        let { value } = e.target

        setInputVal(value)

        if (value.length < 3) {
            setProspectingSuggestions([])
            setStateSuggestions([])
        }

    }

    async function fetchSuggestion(payLoad) {
        const response = await fetchProspectingSuggestion(payLoad)
        setShowSuggestionSpinner(false)

        if (response && response.status === 200) {
            if (response.data && response.data.data) {
                setShow(true)
                setProspectingSuggestions(response.data.data)
            }
        }

    }

    function fetchStateSuggestion() {

        const searchedState = listStates.filter(x => x.label.toLowerCase().includes(inputVal.toLowerCase()))
        let newStateSuggestions = []

        if (searchedState.length > 0) {

            setShow(true)
            setShowSuggestionSpinner(false)

            searchedState.forEach(item => {

                newStateSuggestions.push(
                    {
                        state: item.value,
                        combinedLocation: `${item.label}, USA`,
                        selectedItem: 'state'
                    }
                )
            })
        }
        setStateSuggestions(newStateSuggestions)
    }

    const handleClick = async geoLocation => {

        const newSearchCriteria = { ...searchCriteria }
        // console.log(geoLocation, inputVal)

        if (geoLocation.MetropolitanStateAreaName) {
            geoLocation.selectedItem = 'MetropolitanStateAreaName'
        } else {
            if (geoLocation.city && geoLocation.city.toLowerCase().includes(inputVal.toLowerCase())) {
                geoLocation.selectedItem = 'city'
                delete geoLocation.propertyPropertyCounty
                delete geoLocation.zipCode
                if (!geoLocation.state) {
                    delete geoLocation.state
                }
            }
            if (geoLocation.propertyPropertyCounty && geoLocation.propertyPropertyCounty.toLowerCase().includes(inputVal.toLowerCase())) {
                geoLocation.selectedItem = 'propertyCounty'
                delete geoLocation.city
                delete geoLocation.zipCode
                if (!geoLocation.state) {
                    delete geoLocation.state
                }
            }
            // if (geoLocation.state && geoLocation.state.toLowerCase().includes(inputVal.toLowerCase()) geoLocation.state.includes(inputVal)) {
            //     console.log('geoLocation:::', geoLocation)
            //     geoLocation.selectedItem = 'state'
            // }
            if (geoLocation.zipCode && geoLocation.zipCode.toLowerCase().includes(inputVal.toLowerCase())) {
                geoLocation.selectedItem = 'zipCode'
                delete geoLocation.city
                delete geoLocation.propertyPropertyCounty
                delete geoLocation.state
            }
        }
        // removing county _county from seach criteria
        if(geoLocation.propertyPropertyCounty){
            let county_temp = geoLocation.propertyPropertyCounty.replace(/[_]+/g, "")
            county_temp = county_temp.replace(/County/ig, "")
            county_temp = county_temp.trim()
            geoLocation.propertyPropertyCounty = county_temp
        }

        setShow(false)
        setShowSpinner(true)
        setInputVal('')
        setProspectingSuggestions([])
        setStateSuggestions([])
        newSearchCriteria.sort = {}
        newSearchCriteria.distanceFields = []
        newSearchCriteria.subjectProperty = {}
        newSearchCriteria.pagination.from = 0
        newSearchCriteria.polygon = { points: [] }
        newSearchCriteria.prospecting.push(geoLocation)

        setSearchCriteria({ ...newSearchCriteria })

        setSearchResult({ property: [], totalCount: 0 })

        // const searchResult = new GetSearchResult(newSearchCriteria, function (response, isError) {
        //     setShowSpinner(false)
        //     if (!isError) {
        //         loadData(response, newSearchCriteria, setSearchResult)
        //     }
        // })
        // searchResult.fetchSearchResult()

        const searchResult = new GetSearchResult(newSearchCriteria, function () { })
        const response = await searchResult.fetchSearchResult()
        setShowSpinner(false)
        loadData(response, newSearchCriteria, setSearchResult)
    }

    // window.addEventListener('click', e => {
    //     if (document.getElementById('divProspectingContainer') && !document.getElementById('divProspectingContainer').contains(e.target)) {
    //         if (show) {
    //             setShow(false)
    //         }
    //     }
    // })

    function getSuggestionBy(field) {
        let returnVal = prospectingSuggestions.filter(x => x[field] && x[field].toLowerCase().includes(inputVal.toLowerCase()))

        if (field === 'zipCode') {
            returnVal.forEach(item => {
                delete item.city
                delete item.propertyPropertyCounty
                item.combinedLocation = `${item.zipCode}, ${item.state}`
            });
        }

        if (field === 'propertyPropertyCounty') {
            returnVal.forEach(item => {
                delete item.city
                item.combinedLocation = `${item.propertyPropertyCounty}, ${item.state}`
            });
        }
        return returnVal
    }

    const getCounty = getSuggestionBy('propertyPropertyCounty').reduce((newListOfTags, current) => {
        if (!newListOfTags.some(x => x.propertyPropertyCounty == current.propertyPropertyCounty && x.state == current.state && x.combinedLocation == current.combinedLocation)) {
            newListOfTags.push(current);
        }
        return newListOfTags;
    }, []);

    const getZipCode = getSuggestionBy('zipCode').reduce((newListOfTags, current) => {
        if (!newListOfTags.some(x => x.zipCode == current.zipCode && x.state == current.state && x.combinedLocation == current.combinedLocation)) {
            newListOfTags.push(current);
        }
        return newListOfTags;
    }, []);

    return (
        <>
            <div id="divProspectingContainer" onFocus={() => setShow(true)} onBlur={() => setTimeout(() => setShow(false), 500)} className="leading-xl relative flex w-full flex-wrap items-stretch w-auto">
                {
                    showSuggestionSpinner ?
                        <span className="loader h-6 w-6 items-center justify-center text-center absolute"></span>
                        :
                        <span className="z-10 h-full leading-snug font-normal absolute text-center text-gray-400 absolute bg-transparent rounded text-base items-center justify-center w-6">
                            <svg className="w-5 h-5 fill-current text-gray-500 z-10" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="black"><path d="M0 0h24v24H0V0z" fill="none" /><path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" /></svg>
                        </span>
                }

                <input data-testid="test-input-Search" value={inputVal} style={{ width: 400 }} ref={inputProspecting}
                    onFocus={() => isShowSuggestions(true)} onChange={e => handleChange(e)}
                    className="shadow appearance-none pl-7 pr-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" type="text" placeholder="Search property by location"></input>

                {show && <div style={{ width: 400 }} data-testid="test-div-prospecting-suggestion" className="h-3\/4 md:h-300 overflow-y-auto border-b-1 border-base flex flex-col z-dropdown shadow-2 bg-white origin-top-right absolute mt-7 rounded-md shadow-lg">

                    <div className={`sticky-top flex justify-between border-b-1 border-base px-4 py-3 bg-gray-15 text-primary ${getSuggestionBy('city').length ? '' : 'hidden'}`}>
                        <span>
                            Suggestions by City
                        </span>
                    </div>
                    {getSuggestionBy('city').map((value, index) => (
                        <>
                            <div data-testid="test-state-suggestion" onClick={() => handleClick(value)} role="menuitem" key={index} className="text-left flex flex-col border-b-1 border-base px-4 py-3 cursor-pointer hover:bg-gray-15">
                                {highlightText(value.combinedLocation, inputVal)}
                            </div>
                        </>
                    ))}

                    <div className={`sticky-top flex justify-between border-b-1 border-base px-4 py-3 bg-gray-15 text-primary ${getCounty.length ? '' : 'hidden'} `}>
                        <span>
                            Suggestions by County
                        </span>
                    </div>
                    {getCounty.map((value, index) => (
                        <>
                            <div data-testid="test-state-suggestion" onClick={() => handleClick(value)} role="menuitem" key={index} className="text-left flex flex-col border-b-1 border-base px-4 py-3 cursor-pointer hover:bg-gray-15">
                                {highlightText(value.combinedLocation, inputVal)}
                            </div>
                        </>
                    ))}

                    <div className={`sticky-top flex justify-between border-b-1 border-base px-4 py-3 bg-gray-15 text-primary ${getZipCode.length ? '' : 'hidden'} `}>
                        <span>
                            Suggestions by Zip code
                        </span>
                    </div>
                    {getZipCode.map((value, index) => (
                        <>
                            <div data-testid="test-state-suggestion" onClick={() => handleClick(value)} role="menuitem" key={index} className="text-left flex flex-col border-b-1 border-base px-4 py-3 cursor-pointer hover:bg-gray-15">
                                {highlightText(value.combinedLocation, inputVal)}
                            </div>
                        </>
                    ))}

                    <div className={`sticky-top flex justify-between border-b-1 border-base px-4 py-3 bg-gray-15 text-primary ${getSuggestionBy('MetropolitanStateAreaName').length ? '' : 'hidden'} `}>
                        <span>
                            Suggestions by MSA
                        </span>
                    </div>
                    {getSuggestionBy('MetropolitanStateAreaName').map((value, index) => (
                        <>
                            <div data-testid="test-state-suggestion" onClick={() => handleClick(value)} role="menuitem" key={index} className="text-left flex flex-col border-b-1 border-base px-4 py-3 cursor-pointer hover:bg-gray-15">
                                {/* {highlightText(value.combinedLocation, inputVal)} */}
                                {value.combinedLocation ? highlightText(value.combinedLocation, inputVal) : highlightText(value.MetropolitanStateAreaName, inputVal)}
                            </div>
                        </>
                    ))}

                    <div className={`sticky-top flex justify-between border-b-1 border-base px-4 py-3 bg-gray-15 text-primary ${stateSuggestions.length ? '' : 'hidden'} `}>
                        <span>
                            Suggestions by State
                        </span>
                        {/* <span > <Room /> </span> */}
                    </div>
                    {stateSuggestions.map((value, index) => (
                        <>
                            <div data-testid="test-state-suggestion" onClick={() => handleClick(value)} role="menuitem" key={index} className="text-left flex flex-col border-b-1 border-base px-4 py-3 cursor-pointer hover:bg-gray-15">
                                {highlightText(value.combinedLocation, inputVal)}
                            </div>
                        </>
                    ))}
                </div>}
            </div>
        </>
    )
}

export default GetProspectingSuggestion
